// extracted by mini-css-extract-plugin
export default {"datePickerInputContainer":"verification-link-provider-modal__date-picker-input-container__UIlAl"};